<template>
  <div class="tag-group">
    <span
      v-for="t in tags"
      :key="t.text"
      :class="['tag', `tag-${t.type}`]"
    >{{ t.text }}</span>
  </div>
</template>

<script>
import { getOrderTag } from '@/utils/orderStatus'

export default {
  name: 'OrderTagGroup',
  props: {
    item: { type: Object, required: true }
  },
  computed: {
    tags () { return getOrderTag(this.item) }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.tag-group {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.tag {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: @radius-full;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
}

.tag-primary { background: @primary-soft; color: @primary; }
.tag-success { background: @success-soft; color: @success; }
.tag-warning { background: @warning-soft; color: @warning; }
.tag-danger  { background: @danger-soft; color: @danger; }
.tag-info    { background: @info-soft; color: @info; }
</style>
